import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVideo: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="video, camera, movie, play"><path fillRule="evenodd" clipRule="evenodd" d="M2 4.75C2 4.33579 2.33579 4 2.75 4H15.25C15.6642 4 16 4.33579 16 4.75V8.78648L20.9146 6.32918C21.1471 6.21293 21.4232 6.22536 21.6443 6.36201C21.8654 6.49867 22 6.74007 22 7V17C22 17.2599 21.8654 17.5013 21.6443 17.638C21.4232 17.7746 21.1471 17.7871 20.9146 17.6708L16 15.2135V19.25C16 19.6642 15.6642 20 15.25 20H2.75C2.33579 20 2 19.6642 2 19.25V4.75ZM16 13.5365L20.5 15.7865V8.21353L16 10.4635V13.5365Z" fill="currentColor"/></CentralIconBase>;
};

export default IconVideo;
